export function getWordsAsString(words) {
    return words.map((item) => item.word).join(', ')
}